/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const CameraFlipIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Camera Flip',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M33 8h-7.05L22.6 4.326A1 1 0 0 0 21.859 4h-9.718a1 1 0 0 0-.739.326L8.05 8H1a1 1 0 0 0-1 1v20a1 1 0 0 0 1 1h32a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1ZM17 26.2a8.141 8.141 0 0 1-5.782-2.418l-1.365 1.365A.5.5 0 0 1 9 24.793V20.5a.5.5 0 0 1 .5-.5h4.293a.5.5 0 0 1 .353.854l-1.364 1.364A5.907 5.907 0 0 0 17 24a5.985 5.985 0 0 0 5.51-3.688.5.5 0 0 1 .455-.312h1.291a.5.5 0 0 1 .48.643A8.178 8.178 0 0 1 17 26.2Zm8-10.7a.5.5 0 0 1-.5.5h-4.293a.5.5 0 0 1-.354-.853l1.365-1.365A5.907 5.907 0 0 0 17 12a5.986 5.986 0 0 0-5.51 3.688.5.5 0 0 1-.455.312H9.744a.5.5 0 0 1-.48-.642 8.148 8.148 0 0 1 13.518-3.14l1.364-1.364a.5.5 0 0 1 .854.353Z"
    />
  </svg>`;
};
